import React from 'react';
import { DateTimePicker as BaseDateTimePicker } from './styles/DateTimePicker.styles';
import { TDateTimePickerProps } from './DateTimePicker.types';

export default function DateTimePicker(props: TDateTimePickerProps) {
  return <BaseDateTimePicker {...props} />;
}
